(function () {
    angular.module('SEVENGatewayProductV2', []);
})();

(function () {
    angular
        .module('SEVENGatewayProductV2')
        .controller('SEVENGatewayProductV2Ctrl', SEVENGatewayProductV2Ctrl);

    SEVENGatewayProductV2Ctrl.$inject = [
        '$location',
        '$scope',
        '$rootScope',
        '$state',
        '$document',
        '$window',
        'SEVENConfig',
        'SEVENUser',
        'SEVENSettings',
        'SEVENGatewayService',
        'SEVENWidgetService',
        'SEVENIntegrator',
        'SEVENActiveGames',
        'SEVENRouteService',
        'SEVENToken',
    ];

    function SEVENGatewayProductV2Ctrl(
        $location,
        $scope,
        $rootScope,
        $state,
        $document,
        $window,
        SEVENConfig,
        SEVENUser,
        SEVENSettings,
        SEVENGatewayService,
        SEVENWidgetService,
        SEVENIntegrator,
        SEVENActiveGames,
        SEVENRouteService,
        SEVENToken
    ) {
        var vm = this,
            listeners = {},
            notificationQueue = [],
            toggleSidebarListener,
            showLastTicketsListener,
            showBettingAreaListener,
            config = SEVENConfig,
            user = SEVENUser,
            tokenService = SEVENToken,
            settings = SEVENSettings,
            integrator = SEVENIntegrator,
            gatewayService = SEVENGatewayService,
            widgetService = SEVENWidgetService,
            frameElementDataSetValue = 'slave-frame',
            frameElementSelector = '[data-type=' + frameElementDataSetValue + ']',
            showBalance = user.settings && user.settings.showBalance,
            integrationLayout =
                config.appSettings.config && config.appSettings.config.integrationLayout,
            postLoginData;

        var stateLoadEvent = settings.platform && settings.platform.name + '.StateLoading';

        var init = function () {
            setGlobalIntegrationMode(true);
            vm.integrationMode = settings.mode === 'integration';
            vm.widgetKey = $state.current.data.widgetKey;
            vm.activeProduct = $state.current.data.productDisplayId || false;
            vm.widgetSettings = widgetService.getWidgetByKey(vm.widgetKey);
            vm.isMobile = settings.isMobile;
            vm.shouldAutoresize =
                (!settings.isMobile && integrationLayout === 'regularMobileFixed') ||
                integrationLayout !== 'regularMobileFixed';

            if (vm.activeProduct) SEVENActiveGames.setActiveGame(vm.activeProduct);

            if (!vm.widgetSettings) return;

            setOddTypes();

            // Some widget have their own preloader so 7Web default loader shouldn't be shown
            if (vm.widgetSettings.hideDefaultLoader) {
                vm.loaded = true;
                $scope.$emit(stateLoadEvent, false);
            } else {
                $scope.$emit(stateLoadEvent, true);
            }

            vm.onFinally = onLoaded;
            vm.source = vm.widgetSettings.source[0];
            vm.scrolling =
                vm.widgetSettings.scrolling === undefined ? 'auto' : vm.widgetSettings.scrolling;

            setSlaveListeners();
            setInAppListeners();
        };

        var setOddTypes = function () {
            var stateData = $state.current.data;
            var hasOddsSelector = stateData.hasOwnProperty('oddsSelector')
                ? !!stateData.oddsSelector
                : true;

            if (vm.activeProduct && hasOddsSelector) {
                var oddTypesConfig = Object.values(config.client.oddTypes);
                var defaultOddType = config.client.oddTypes[1].title;
                var oddTypesList = oddTypesConfig.map(function (item) {
                    return item.title; // TODO item.code should be used here but currently whole oddtype service uses titles
                });

                $scope.$emit('SEVEN.ProductOddTypes', {
                    product: vm.activeProduct,
                    oddTypes: {
                        active: defaultOddType,
                        default: defaultOddType,
                        supported: oddTypesList,
                    },
                });
            }
        };

        /**
         * @method
         * @see checkForSafariForwardCaching
         */
        var setGlobalIntegrationMode = function (isIntegrationMode) {
            window.SEVENGlobals.isIntegrationMode = isIntegrationMode;
        };

        /* Set listeners */
        var setSlaveListeners = function () {
            listeners['User.LoginRequired'] = gatewayService.listen(
                'User.LoginRequired',
                function (message) {
                    if (vm.integrationMode) {
                        integrator.sendMessage({
                            type: 'loginRequired',
                        });

                        return;
                    }

                    var postLogin = message.data && message.data.postLogin;

                    if (postLogin) {
                        postLoginData = postLogin;
                    }

                    if (!tokenService.getToken()) $rootScope.$broadcast('SEVEN.ShowLoginDialog');
                }
            );

            listeners['User.Logout'] = gatewayService.listen('User.Logout', function () {
                if (tokenService.getToken()) $rootScope.$broadcast('SEVEN.PlayerLogout');
            });

            listeners['User.LogoutSuccess'] = gatewayService.listen('User.LogoutSuccess');

            listeners['Tickets.*'] = gatewayService.listen('Tickets.*');

            listeners['Tickets.Pay'] = gatewayService.listen('Tickets.Pay');

            listeners['Tickets.Resolved'] = gatewayService.listen(
                'Tickets.Resolved',
                function (message) {
                    if (message.data.ticket && message.data.accepted) {
                        var ticketProduct = {
                            product: vm.activeProduct,
                        };
                        var expandedTicket = angular.extend({}, message.data.ticket, ticketProduct);

                        $scope.$emit('SEVEN.TicketResolved', expandedTicket);
                        $scope.$emit('TicketPayinCompleted', expandedTicket);
                    }
                }
            );

            listeners['Tickets.Changed'] = gatewayService.listen(
                'Tickets.Changed',
                function (message) {
                    $scope.$applyAsync($scope.$emit('SEVEN.TicketChanged', message.data.ticket));
                }
            );

            listeners['Tickets.Check'] = gatewayService.listen('Tickets.Check');

            listeners['Tickets.UpdateTicketCheckState'] = gatewayService.listen(
                'Tickets.UpdateTicketCheckState'
            );

            listeners['Betslip.*'] = gatewayService.listen('Betslip.*');

            listeners['Notifications.Show'] = gatewayService.listen('Notifications.Show');

            listeners['Peripherals.Print'] = gatewayService.listen('Peripherals.Print');

            // Deprecated, should be replaced with Router.GoTo and UI.Show https://phabricator.nsoft.ba/T99317
            listeners['Router.GoToRoute'] = gatewayService.listen(
                'Router.GoToRoute',
                function (message) {
                    var state = message.data && message.data.state;

                    // Check if valid state name
                    if (state && $state.get(state.name)) {
                        if (state.params) {
                            $state.go(state.name, state.params).catch(angular.noop);
                        } else {
                            $state.go(state.name).catch(angular.noop);
                        }
                    }
                }
            );

            listeners['Router.RouteChanged'] = gatewayService.listen(
                'Router.RouteChanged',
                function (message) {
                    if (!message.data.params) {
                        return;
                    }

                    $state.transitionTo($state.current, message.data.params, {
                        notify: false,
                    });
                }
            );

            listeners['Router.GoTo'] = gatewayService.listen('Router.GoTo', function (message) {
                var destination = message.data;

                if (!destination.target) {
                    var matchingState = SEVENRouteService.findMatchingStateByUrl(destination.url);
                    var urlForIntegrator = message.data.url;

                    if (matchingState) {
                        var isSameAsCurrent = matchingState.name === $state.current.name;
                        var transitionOptions = isSameAsCurrent ? { notify: false } : null;

                        if (matchingState.pathname) {
                            urlForIntegrator = matchingState.pathname;
                        }

                        $state
                            .transitionTo(
                                matchingState.name,
                                matchingState.params,
                                transitionOptions
                            )
                            .then(function () {
                                if (!isSameAsCurrent) return;

                                gatewayService.emitRouteChanged(
                                    null,
                                    null,
                                    $window.location.pathname,
                                    matchingState.params
                                );
                            });
                    } else {
                        window.location = message.data.url;
                    }

                    if (vm.integrationMode) {
                        integrator.sendMessage({
                            type: 'routeChanged',
                            data: {
                                url: urlForIntegrator,
                            },
                        });
                    }
                } else if (destination.target === '_blank') {
                    window.open(destination.url, '_blank').focus();
                } else if (destination.target === '_top') {
                    if (vm.integrationMode) {
                        try {
                            window.top.location.href = destination.url;
                        } catch (error) {
                            console.error(
                                '[SEVEN] Error in navigation to ' +
                                    destination.url +
                                    '. Allow navigation from ' +
                                    location.origin +
                                    'iframe to solve this error',
                                error
                            );
                        }
                    } else {
                        window.location.href = destination.url;
                    }
                }
            });

            listeners['Router.GoBack'] = gatewayService.listen('Router.GoBack', function () {
                window.history.back();
            });

            listeners['Router.GoForward'] = gatewayService.listen('Router.GoForward', function () {
                window.history.forward();
            });

            listeners['Dialog.ShowModal'] = gatewayService.listen('Dialog.ShowModal');

            listeners['Proxy.Send'] = gatewayService.listen('Proxy.Send');

            listeners['Widget.Loading'] = gatewayService.listen('Widget.Loading');

            listeners['Widget.SettingsChanged'] = gatewayService.listen('Widget.SettingsChanged');

            listeners['Roles.GetRoles'] = gatewayService.listen('Roles.GetRoles');

            var handleUiShowHide = function (message) {
                var name = message.data && message.data.name;
                var isBetslip = name && name.includes('Betslip');
                var isTicketHistory = name && name.includes('TicketHistory');
                var isLobby = name && name.includes('Lobby');
                var isPlayerVerification = name && name.includes('PlayerVerification');
                var currentStateData = $state.current.data;

                var action = message.action.split('.').pop();
                var shouldBeClosed = action === 'Hide';
                var shouldBeShown = action === 'Show';

                $rootScope.$broadcast(message.action, message.data);

                if (user.logged && isPlayerVerification && shouldBeShown)
                    $state.go('PlayerProfile').catch(angular.noop);

                if (isBetslip) {
                    $scope.toggleSidebar(shouldBeClosed, true);
                }

                // Navigate to player history for appropriate product
                // For now, this is related this to current route, later should be implemented with slaveId
                if (isTicketHistory && shouldBeShown) {
                    var historyDefinition = currentStateData.ticketHistory || {};
                    var params = {
                        section: historyDefinition.section,
                        type: historyDefinition.type,
                    };

                    $state.go('PlayerHistory', params).catch(angular.noop);
                }

                if (isLobby && shouldBeShown) {
                    var parentState = currentStateData.parent || 'Home';

                    $state.go(parentState).catch(angular.noop);
                }
            };

            listeners['UI.Show'] = gatewayService.listen('UI.Show', handleUiShowHide);
            listeners['UI.Hide'] = gatewayService.listen('UI.Hide', handleUiShowHide);

            listeners['UI.Updated'] = gatewayService.listen('UI.Updated', function (message) {
                $rootScope.$broadcast('SEVEN.ProductUiUpdated', message.data);
            });

            listeners['Slave.Event'] = gatewayService.listen('Slave.Event', function (message) {
                $scope.$applyAsync(function () {
                    if (message.event.startsWith('Game.')) {
                        config.balanceToggleEnabled = message.event === 'Game.Close';
                    }

                    if (message.event === 'Game.Open') {
                        if (user.logged) {
                            showBalance = user.settings.showBalance;
                            user.settings.showBalance = false;
                            user.settings.forceHideBalance = true;
                        }

                        $scope.$emit('SEVEN.CasinoGameOpened', message.data.game);
                        $scope.$emit('SEVEN.TogglePullToRefresh', false);
                    } else if (message.event === 'Game.Close') {
                        if (user.logged) {
                            user.getThrottledBalance();
                            resetUserBalanceDisplay();
                        }

                        $rootScope.$broadcast('SEVEN.ResetMeta');
                        $scope.$emit('SEVEN.TogglePullToRefresh', true);
                        $scope.$emit('SEVEN.CasinoGameClosed', message.data.game);
                    } else if (message.event === 'click') {
                        var event = document.createEvent('Event');
                        var eventOrigin = $document.find(frameElementSelector);

                        event.initEvent('click', true, true);
                        eventOrigin[0].dispatchEvent(event);
                    }
                });
            });

            listeners['Document.ChangeMeta'] = gatewayService.listen(
                'Document.ChangeMeta',
                function (message) {
                    $rootScope.$broadcast('SEVEN.SetMeta', message.data);
                }
            );

            listeners['Document.ChangeTitle'] = gatewayService.listen(
                'Document.ChangeTitle',
                function (message) {
                    $rootScope.$broadcast('SEVEN.SetTitle', message.data);
                }
            );

            listeners['Analytics.Send'] = gatewayService.listen(
                'Analytics.Send',
                function (message) {
                    $scope.$emit('SEVEN.AnalyticsEvent', message.data);
                }
            );
        };

        var setInAppListeners = function () {
            $scope.$watch(
                function () {
                    return tokenService.getToken();
                },
                function (current, previous) {
                    if (current) {
                        if (current !== previous) {
                            sendAuth(current);
                            unsetPostLoginData();
                        }
                    } else {
                        if (previous) {
                            sendAuth();
                        }
                    }
                }
            );

            $scope.$watch(
                function () {
                    return integrator.getThirdPartyToken();
                },
                function (current, previous) {
                    if (current !== previous) {
                        sendAuth(tokenService.getToken());
                    }
                }
            );

            $scope.$watch('user.profile', function (current, previous) {
                if (current !== previous) {
                    sendAuth();
                }
            });

            $scope.$watch('user.balanceTotal', function (current, previous) {
                if (current !== previous) {
                    sendBalance(current);
                }
            });

            $scope.$watch('user.settings.showBalance', function (current, previous) {
                if (current !== previous) {
                    gatewayService.emitUserSettingsChanged({
                        // Deprecated
                        showBalance: current,
                    });

                    gatewayService.emitSettingsChanged({
                        showBalance: current,
                    });
                }
            });

            $scope.$watch('user.settings.oddType', function (current, previous) {
                if (current !== previous) {
                    gatewayService.emitSettingsChanged({
                        oddType: current,
                    });
                }
            });

            $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
                // Slave doesn't care about navigation away from its page
                if (toState.name !== fromState.name) return;

                gatewayService.emitRouteChanged(toState, fromState, $location.path(), toParams);
            });

            $scope.$on('SEVEN.PlayerNotificationClicked', function (event, params) {
                // Persisting notification until Slave asks for it.
                // This covers the case when notification has been clicked on,
                // but Slave had not yet been loaded ATM of click,
                // so the dispatched notification wouldn't be acknowledged in Slave.
                if (params.wasRedirectedOnClick) {
                    // If user was redirected to a different route on notification click,
                    // persist notification in array, until Slave asks for dispatch
                    notificationQueue.push(params.notification);
                } else {
                    // Dispatch notification to Slaves right away
                    gatewayService.emitNotificationClicked(params.notification);
                }
            });

            $scope.$on('SEVEN.PlayerNotificationExpired', function (event, params) {
                gatewayService.emitNotificationExpired(params.notification);
            });

            $scope.$on('SEVEN.TicketRebet', function (event, tickets) {
                gatewayService.emitToAllSlaves({
                    action: 'Tickets.Rebet',
                    data: {
                        ticket: tickets[0],
                    },
                });
            });

            $document.on('click', emitOutsideClick);

            /**
             * Listen for sidebar show state and emit it to slave.
             *
             * @method
             * @param {SEVEN.ToggleSidebar} data - An event data.
             * @listens SEVEN.ToggleSidebar
             */
            toggleSidebarListener = $rootScope.$on('SEVEN.ToggleSidebar', function (event, data) {
                gatewayService.emitBetslipToggled(data);
            });

            /**
             * Listen for last tickets action and emit it to slave.
             * @method
             * @listens SEVEN.ShowLastTickets
             */
            showLastTicketsListener = $rootScope.$on('SEVEN.ShowLastTickets', function () {
                gatewayService.emitUIChange('Show', ['LastTickets']);
            });

            /**
             * Listen for betting area action and emit it to slave.
             * @method
             * @listens SEVEN.ShowBettingArea
             */
            showBettingAreaListener = $rootScope.$on('SEVEN.ShowBettingArea', function () {
                gatewayService.emitUIChange('Show', ['BettingArea']);
            });

            $scope.$on('SEVEN.LoginDialogClosed', function (event, options) {
                if (options.closedByUser) {
                    unsetPostLoginData();
                }
            });

            /**
             * Listen for betting disabled message and emit it to slave.
             * @method
             * @listens SEVEN.BettingDisabledByParent
             */
            $scope.$on('SEVEN.BettingDisabledByParent', function (event, isDisabled) {
                var action = isDisabled ? 'Blocked' : 'Unblocked';

                gatewayService.emitToAllSlaves({
                    action: 'Betslip.' + action,
                });
            });
        };

        var sendState = function () {
            if (tokenService.getToken()) {
                sendAuth(tokenService.getToken());
            } else {
                sendAuth();
            }

            if (user.balanceTotal) sendBalance(user.balanceTotal);
        };

        var sendAuth = function (token) {
            gatewayService.emitAuthorizationChanged(
                {
                    token: token || tokenService.getToken() || null,
                    tpToken: integrator.getThirdPartyToken(),
                    user:
                        user &&
                        angular.merge({}, user, {
                            token: token || tokenService.getToken() || null,
                        }),
                },
                postLoginData
            );
        };

        var sendBalance = function (balance) {
            gatewayService.emitBalanceChanged(balance);
        };

        var emitOutsideClick = function (e) {
            var targetDataset = e.target.dataset;

            // Don't propagate click event that originated from frame
            if (targetDataset && targetDataset.type === frameElementDataSetValue) {
                return;
            }

            // close sidebar with stopped propagation
            $scope.toggleSidebar(true, true);

            gatewayService.emitOutsideClick();
        };

        var dispatchQueuedNotifications = function () {
            // Dispatch each notification to Slaves
            angular.forEach(notificationQueue, function (notification, i) {
                gatewayService.emitNotificationClicked(notification);
                // Remove notification from array
                notificationQueue.splice(i);
            });
        };

        var onLoaded = function () {
            $scope.$applyAsync(function () {
                vm.loaded = true;
                $scope.$emit(stateLoadEvent, false);
                // Notify parent
                integrator.sendMessage({
                    type: 'contentLoaded',
                });
                // after frame is ready send lates user state
                sendState();
                // Ask parent 'gateway-product' to deliver queued notifications
                dispatchQueuedNotifications();
            });
        };

        var removeListeners = function () {
            $document.off('click', emitOutsideClick);
            toggleSidebarListener();
            showLastTicketsListener();
            showBettingAreaListener();

            Object.keys(listeners).forEach(function (key) {
                listeners[key].remove();
            });
        };

        var resetUserBalanceDisplay = function () {
            user.settings.showBalance = showBalance;
            user.settings.forceHideBalance = false;
            config.balanceToggleEnabled = true;
        };

        var unsetPostLoginData = function () {
            postLoginData = undefined;
        };

        $scope.$on('$destroy', function () {
            resetUserBalanceDisplay();
            removeListeners();
            setGlobalIntegrationMode(false);
        });

        init();
    }
})();
